export const isExternalBuyer = (user) =>
  user?.roles?.includes('buyer_external');

/** Prefer qtyAvailable; fall back to qtyOnHand when missing. */
export const getProductInventoryQty = (product) =>
  product?.qtyAvailable ?? product?.qtyOnHand ?? 0;

export const getProductInventoryLabel = (product) =>
  product?.qtyAvailable != null ? 'Available' : 'QoH';

/** Column header when the table lists many products. */
export const getInventoryColumnLabel = () => 'Available Qty';

/**
 * Returns the quantity to display/validate against, or null if hidden.
 * External buyers do not see stock quantities.
 */
export const getInventoryQty = (product, user) => {
  if (isExternalBuyer(user)) return null;
  return getProductInventoryQty(product);
};

export const getInventoryLabel = (product, user) => {
  if (isExternalBuyer(user)) return null;
  return getProductInventoryLabel(product);
};
